"use client";

import { useEffect } from "react";

/**
 * Client component to apply the "org" theme class to the body element
 * This allows HeroUI's org theme to be used for organization-specific branding
 */
export function OrgThemeApplier() {
  useEffect(() => {
    // Remove "light" theme class and add "org" theme class
    const body = document.body;

    if (body.classList.contains("light")) {
      body.classList.remove("light");
    }

    body.classList.add("org");

    // Cleanup: restore light theme when component unmounts
    // (though this shouldn't happen in practice since it's in the layout)
    return () => {
      body.classList.remove("org");
      body.classList.add("light");
    };
  }, []);

  return null;
}
